import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "daos_admin_token";

export const adminApi = axios.create({ baseURL: API });

adminApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/admin/login")) {
        window.location.replace("/admin/login");
      }
    }
    return Promise.reject(err);
  }
);

export const authApi = {
  async login(email, password) {
    const { data } = await axios.post(`${API}/admin/login`, { email, password });
    localStorage.setItem(TOKEN_KEY, data.access_token);
    return data.user;
  },
  async me() {
    const { data } = await adminApi.get("/admin/me");
    return data;
  },
  logout() {
    localStorage.removeItem(TOKEN_KEY);
  },
  hasToken() {
    return !!localStorage.getItem(TOKEN_KEY);
  },
};
